import React, { useState, useEffect } from 'react';
import {
  IconCheckCircle,
  IconReportHeptagon,
  IconAlertTriangle,
  IconInfoCircle,
  IconClose,
} from '@/icons';

import * as Styles from './FloatingToast.styles';

const getIcon = (context) => {
  switch (context) {
    case 'success': return <IconCheckCircle />;
    case 'info': return <IconInfoCircle />;
    case 'warning': return <IconAlertTriangle />;
    case 'error': return <IconReportHeptagon />;
    default: return <IconInfoCircle />;
  }
};

export const FloatingToast = ({
  title,
  message,
  context = 'info',
  duration = 5000,
  showIcon = true,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <Styles.ToastContainer $context={context}>
      {showIcon && getIcon(context)}
      <Styles.Content>
        {title && <Styles.Title $context={context}>{title}</Styles.Title>}
        <Styles.Message>{message}</Styles.Message>
      </Styles.Content>
      {onClose && (
        <Styles.CloseButton
          onClick={() => {
            setIsVisible(false);
            onClose();
          }}
        >
          <IconClose size={20} color={context === 'error' ? '#FFFFFF' : '#CDD8DF'} />
        </Styles.CloseButton>
      )}
    </Styles.ToastContainer>
  );
};
